import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "templateSelect", "rejectReasonInput" ]

  connect() {
    $(this.templateSelectTarget).on('select2:select', this.fillRejectReason.bind(this));
    $(this.templateSelectTarget).on('select2:unselect', this.clearRejectReason.bind(this));
  }
  fillRejectReason() {
    this.rejectReasonInputTarget.value = this.templateSelectTarget.value;
  }

  clearRejectReason() {
    this.rejectReasonInputTarget.value = "";
  }
}
